module.exports = __webpack_public_path__ + "img/chips1.8df36356.png";